<template>
  <div>
    <div class="container">
      <NavBar class="nav-bar" :options="options" title="传播有礼" :zIndex="10">
        <template slot="right">
          <div
            @click="bindInviteFriend"
            class="share iconfont icon-gengduo1"
          ></div>
        </template>
      </NavBar>
      <!--   <div class="rule-btn" @click="jumpRules">活动规则</div> -->
      <div class="bg1">
        <img
          class="bg1-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/56f58b7a19767e1c26514ff0df0ef159.png"
          alt=""
        />
      </div>
      <PaoMaDeng
        :delay="0"
        :speed="80"
        :content="winnerList"
        class="paomadeng"
        v-if="winnerList.length"
      >
        <div
          class="paomadeng-item"
          v-for="(item, index) in winnerList"
          :key="index"
        >
          <div class="avatar-container">
            <img class="item-avatar" :src="item.head_img" alt="" />
          </div>
          <div class="item-text">
            {{
              item.truename + ' ' + item.phone + '已成功传播' + item.num + '人'
            }}
          </div>
        </div>
      </PaoMaDeng>
      <div class="padding-content">
        <div class="ra-item invite-content">
          <div class="ra-title">传播好友您可得</div>
          <div class="award-list">
            <img
              class="award-item"
              v-for="(item, index) in prizeList"
              :key="index"
              :src="item.index_img"
              alt=""
            />
          </div>
          <InvitePerson
            :list="invitePersonList"
            :current="currentPerson"
          ></InvitePerson>
          <div class="tips"
            ><span>惊喜彩蛋：本期传播人数最高者</span> <br /><span
              >可额外获得</span
            ><span class="pink">100元商城券包</span></div
          >
          <div class="check-record">
            <div class="text" @click="bindInviteRecord">查看传播记录</div>
          </div>
        </div>
        <img
          class="image-item"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4a3dfc4daaa6bbda12fc25e41d4c6a1e.png"
          alt=""
        />
        <img
          class="image-item"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/db84a954571e83a9fdd2271e0e57f6d0.png"
          alt=""
        />
        <div class="rule-content ra-item" v-if="ruleData">
          <div class="ra-title">活动规则</div>
          <div class="rule-text" v-html="ruleData"></div>
        </div>
      </div>
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
      <!-- 底部固定按钮 -->
      <div class="btn-content" v-if="userInfo">
        <div class="btn-item btn-left" @click="bindInviteRecord">
          查看传播记录
        </div>
        <div
          class="btn-item btn-right"
          :class="{ 'disabled-btn': userInfo.activity_state != 1 }"
          @click="bindInviteFriend"
        >
          <span v-if="userInfo.activity_state == 0">活动未开始</span>
          <span v-else-if="userInfo.activity_state == 2">活动已结束</span>
          <span v-else
            ><span class="iconfont icon-shuffling-banner-fill"></span
            ><span>生成传播图</span></span
          >
        </div>
      </div>
    </div>
    <van-overlay :show="showPoster" @click="showPoster = false" z-index="10">
      <PosterComponent
        :data="activityInfo"
        :userInfo="userInfo"
        v-if="showPoster"
        @close="bindClose"
      />
    </van-overlay>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#999"
      color="#999"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import NavBar from '@/components/app/nav-bar/index.vue'
import PaoMaDeng from '../goddess-festival/ponents/paomadeng.vue'
import PosterComponent from './components/poster.vue'
import InvitePerson from './components/invite-person.vue'
export default {
  components: {
    NavBar,
    PaoMaDeng,
    PosterComponent,
    InvitePerson
  },
  data() {
    return {
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)',
        color: '#000'
      },
      loaded: false,
      showPoster: false,
      leftNum: 0, //剩余次数
      inviteId: '', //邀请id
      activityInfo: null, //活动信息
      userInfo: null, //用户信息
      ruleData: '', //规则
      winnerList: [],
      activityId: 2, //活动id
      invitePersonList: [],
      currentPerson: 0,
      prizeList: []
    }
  },
  computed: {
    activityTime() {
      if (
        !this.activityInfo ||
        !this.activityInfo.begin_time ||
        !this.activityInfo.end_time
      ) {
        return ''
      }
      let start = this.activityInfo.begin_time
      let end = this.activityInfo.end_time
      let startStr =
        parseInt(start.slice(5, 7)) + '月' + parseInt(start.slice(8, 10)) + '日'
      let endStr =
        parseInt(end.slice(5, 7)) + '月' + parseInt(end.slice(8, 10)) + '日'
      let res = '活动时间：' + startStr + '-' + endStr
      return res
    }
  },
  created() {
    this.getParams()
    this.getData()
    this.getForward()
    this.getActivityInfo()
    //app分享活动页面曝光事件
    this.$buryPoint('APP_SHARE_ACTIVITY_V2', {})
  },
  mounted() {
    this.addScroll()
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    getParams() {
      this.activityId = this.$route.query.activityId
    },
    //跑马灯
    getForward() {
      let params = {
        activity_id: this.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/activityMarquee', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.winnerList = res.data || []
          }
        })
        .catch(() => {})
    },
    getData() {
      let params = {
        activity_id: this.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/createReceiveCode', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.leftNum = res.data.left_time
            this.inviteId = res.data.invitation_id
            this.currentPerson = res.data.invited_num
            this.userInfo = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    bindInviteRecord() {
      if (this.userInfo.activity_state == 0) {
        this.$toast('活动未开始')
        return
      }
      if (!this.userInfo) {
        return
      }
      this.$router.push({
        path: '/camp-invite-v3/inviteSchedule',
        query: {
          activityId: this.activityId,
          inviteId: this.inviteId
        }
      })
    },
    bindInviteFriend() {
      if (this.userInfo.activity_state == 0) {
        this.$toast('活动未开始')
        return
      }
      if (this.userInfo.activity_state == 2) {
        this.$toast('活动已结束')
        return
      }
      if (!this.userInfo) {
        return
      }
      this.showPoster = true
      //app分享活动分享次数
      this.$buryPoint('APP_SHARE_ACTIVITY_V2_SHARE_NUM', {})
    },
    getActivityInfo() {
      let params = {
        id: this.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/getActivityInfo', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.activityInfo = res.data
            this.ruleData = res.data.invitation_activity_rule
            this.prizeList = res.data.prize_list
            let arr = this.prizeList.map((item) => {
              return item.min_receive_num
            })
            arr.unshift(0)
            this.invitePersonList = arr
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loaded = true
        })
    },
    jumpRules() {
      if (!this.inviteId) {
        return
      }
      this.$router.push({
        path: '/camp-invite/rules',
        query: {
          type: 1
        }
      })
    },
    bindClose() {
      this.showPoster = false
    },
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: rgba(225, 216, 255, 1);
  min-height: 100vh;
  overflow: hidden;
  // IOS底部兼容
  padding-bottom: calc(50px + 0.5 * constant(safe-area-inset-bottom));
  padding-bottom: calc(
    50px + 0.5 * env(safe-area-inset-bottom)
  ); //兼容 IOS>11.2;
}
.bg1 {
  width: 100%;
  height: 400px;
  margin-bottom: 11px;
  .bg1-image {
    width: 100%;
  }
}
.paomadeng {
  width: 100%;
  padding-left: 60px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
.activity-time {
  text-align: center;
  position: absolute;
  top: 220px;
  left: 0;
  width: 100%;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
  font-weight: 600;
  color: #ffffff;
  line-height: 22px;
}
.paomadeng-item {
  display: flex;
  align-items: center;
  margin-right: 8px;
  height: 40px;
  background: rgba(71, 49, 131, 0.4);
  border-radius: 12px;
  padding: 4px 15px;
  box-sizing: border-box;
  .avatar-container {
    position: relative;
  }
  .item-active {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 40%;
    bottom: 50%;
    z-index: 1;
  }
  .item-avatar {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    overflow: hidden;
    margin-right: 10px;
    object-fit: cover;
  }
  .item-text {
    white-space: nowrap;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #fff;
    line-height: 18px;
  }
}
.padding-content {
  position: relative;
  padding: 0px 16px;
  box-sizing: border-box;
  .invite-content {
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .award-list {
      display: flex;
      align-items: center;
      margin-bottom: 17px;
      .award-item {
        width: 99px;
        height: 208px;
        object-fit: contain;
        background: #ffffff;
        border-radius: 9px;
        margin-right: 8px;
      }
    }
    .tips {
      text-align: center;
      margin: 0 auto 16px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #473183;
      line-height: 21px;
      .pink {
        font-weight: 600;
        color: rgba(126, 77, 254, 1);
      }
    }
    .check-record {
      text-align: center;
      .text {
        text-decoration: underline;
        display: inline-block;
        font-size: 15px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #473183;
        line-height: 21px;
      }
    }
  }
  .image-item {
    width: 100%;
    margin-bottom: 20px;
  }
  .ra-item {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    .ra-title {
      text-align: center;
      font-size: 24px;
      font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
      font-weight: 600;
      color: #473183;
      line-height: 33px;
      margin-bottom: 16px;
    }
  }
  .rule-content {
    padding: 16px 20px;
    margin-bottom: 24px;
    .rule-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: #473183;
      line-height: 24px;
    }
  }
}
.logo {
  display: block;
  margin: 0 auto 21px;
  height: 14px;
}
.btn-content {
  position: fixed;
  width: 100%;
  bottom: 0px;
  left: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  height: 48px;
  // IOS底部兼容
  height: calc(48px + 0.5 * constant(safe-area-inset-bottom));
  height: calc(48px + 0.5 * env(safe-area-inset-bottom)); //兼容 IOS>11.2;
  background: #755b9b;
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 48px;
  .btn-item {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-left {
    text-align: center;
    width: 147px;
    background: rgba(0, 0, 0, 0.8);
  }
  .btn-right {
    flex: 1;
    background: #fe3875;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      color: #fff;
      font-size: 15px;
      margin-right: 10px;
    }
  }
  .disabled-btn {
    background-color: #999;
  }
}
.rule-btn {
  position: fixed;
  right: 0;
  top: 110px;
  width: 32px;
  display: flex;
  text-align: center;
  background: #6f60a2;
  border-radius: 8px 0px 0px 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 15px;
  z-index: 1;
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
.share {
  font-size: 24px;
  font-weight: 600;
}
</style>
